var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.inprogress)?_vm._t("default"):_c('div',{staticClass:"wait_indicator center-block"},[_c('i',{staticClass:"center-block fa fa-spinner fa-spin",attrs:{"alt":"wait"}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }